/** Normalize roles from API (array or legacy shapes). */
export function accountRoles(accountOrRoles) {
  const roles = accountOrRoles?.roles ?? accountOrRoles;
  if (!roles) {
    return [];
  }
  if (Array.isArray(roles)) {
    return roles
      .map((r) => (typeof r === 'string' ? r : r?.name))
      .filter(Boolean);
  }
  return [];
}

export function hasAccountRole(account, roleName) {
  return accountRoles(account).includes(roleName);
}

export function isOrgAdmin(account) {
  return hasAccountRole(account, 'ADMIN') || hasAccountRole(account, 'ROOT');
}

export function formatRoleLabel(roleName) {
  switch (roleName) {
    case 'ADMIN':
    case 'ROOT':
      return 'Admin';
    case 'EDITOR':
      return 'Editor';
    case 'USER':
      return 'Reader';
    default:
      return roleName ?? '';
  }
}

export function primaryRoleLabel(account) {
  const roles = accountRoles(account);
  if (roles.includes('ADMIN') || roles.includes('ROOT')) {
    return 'Admin';
  }
  if (roles.includes('EDITOR')) {
    return 'Editor';
  }
  if (roles.includes('USER')) {
    return 'Reader';
  }
  return roles[0] ? formatRoleLabel(roles[0]) : '—';
}

export function memberDisplayName(account) {
  const name = [account?.firstName, account?.lastName]
    .filter(Boolean)
    .join(' ');
  return name || account?.accountName || '—';
}

export const ASSIGNABLE_MEMBER_ROLES = [
  { value: 'EDITOR', label: 'Editor' },
  { value: 'USER', label: 'Reader' },
];
